import { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import OmsService from "src/_cores/_services/oms.service";
import {
  HeaderStatCard,
  OrderStatisticsResponse,
} from "src/_pages/admin/interfaces/oms-interface";
import { mapOrderStatisticToHeader } from "src/_shares/_helpers/order.helper";
import OrdersStatisticalView from "./OrdersStatisticalView";
import { StatCardProps } from "../star-card";
import { Grid } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const OrdersStatistical = () => {
  const [data, setData] = useState<OrderStatisticsResponse | null>(null);
  const [labels, setLabels] = useState<string[]>([]);
  const [orders, setOrders] = useState<number[]>([]);
  const [headerData, setHeaderData] = useState<StatCardProps[]>([]);

  const today = dayjs();
  const thirtyDaysAgo = today.subtract(30, "day");

  const [params, setParams] = useState<{
    fromDate: Dayjs | null;
    toDate: Dayjs | null;
    status: string | null;
  }>({
    fromDate: thirtyDaysAgo,
    toDate: today,
    status: null,
  });

  useEffect(() => {
    fetchStatistic();
  }, [params.fromDate, params.toDate]);

  const onChangeDate = (type: "fromDate" | "toDate", date: Dayjs | null) => {
    const _params = {
      ...params,
      [type]: date
        ? new Date(Date.UTC(date.year(), date.month(), date.date(), 0, 0, 0, 0))
        : null,
    };
    setParams(_params);
  };

  const fetchStatistic = async () => {
    const from = params.fromDate
      ? dayjs(params.fromDate).format("YYYY-MM-DD")
      : null;

    const to = params.toDate
      ? dayjs(params.toDate).format("YYYY-MM-DD")
      : null;

    const res = (await OmsService.getOrderStatistic(from, to, null)) as any;

    const data = res?.data;

    if (data) {
      setData(data);

      const labels = data.byMonth?.map((x: any) => x?.label ?? "") ?? [];
      const orders = data.byMonth?.map((x: any) => x?.orderCount ?? 0) ?? [];

      setLabels(labels);
      setOrders(orders);

      const mapped = mapOrderStatisticToHeader(data);
      setHeaderData(mapped);
    }
  };

  if (!data) return null;

  return (
    <>
      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Từ ngày"
              value={params.fromDate ? dayjs(params.fromDate) : null}
              onChange={(newValue) => onChangeDate("fromDate", newValue)}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Đến ngày"
              value={params.toDate ? dayjs(params.toDate) : null}
              onChange={(newValue) => onChangeDate("toDate", newValue)}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <OrdersStatisticalView
        labels={labels}
        orders={orders}
        headerData={headerData}
      />
    </>
  );
};

export default OrdersStatistical;
